import { Component, OnInit, Input , Output, EventEmitter} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailRegex, ShareReq } from '../../../../classes/leads';
import { DomManipulationService } from '../../../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../../../classes/dynamicScripts';
import { HasSubscriptions } from '../../../../components/has-subscriptions';
import { LeadsService } from '../../../../services/leads.service';
import { ErrorService, ErrorKey } from '../../../../services/error.service';

@Component({
  selector: 'app-email-share-modal',
  templateUrl: './email-share-modal.component.html',
  styleUrls: ['./email-share-modal.component.scss']
})
export class EmailShareModalComponent extends HasSubscriptions implements OnInit {
  @Input() isLuxury: boolean = false;
  @Input() isCommercial: boolean = false;
  @Input() fromEmail: string = '';
  @Input() subjectTitle: string = '';
  @Input() url: string;
  @Input() description: string;

  @Output() submitted: EventEmitter<any> = new EventEmitter();
  style: string = '';
  contactForm: FormGroup;
  recaptchaId: number;
  isLoading: boolean = false;
  constructor(private domManipulationService: DomManipulationService, private leadService: LeadsService, private errorService: ErrorService) {
    super();
  }

  ngOnInit() {
    this.contactForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.pattern(emailRegex)]),
      from: new FormControl(null,  Validators.required),
      subject: new FormControl(null, Validators.required),
      listingUrl: new FormControl(null, Validators.required),
      comments: new FormControl(null, Validators.required),
    })

    this.contactForm.controls['from'].setValue(this.fromEmail);
    this.contactForm.controls['subject'].setValue(this.subjectTitle);
    this.contactForm.controls['listingUrl'].setValue(this.url);
    this.contactForm.controls['comments'].setValue(this.description);
    this.style = this.isLuxury ? 'luxury' : '';
  }

  sendGrecaptcha() {
    this.addSub(
      this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(() => {
        grecaptcha.execute(this.recaptchaId);
      })
    );
  }

  getOnSubmit(): (recaptchaKey: string) => void {
    return this.onSubmit.bind(this);
  }

  onSubmit(recaptchaKey: string) {
    if (!this.contactForm.valid) return;

    const payload: ShareReq = {
      email: this.contactForm.controls['email'].value,
      from: this.contactForm.controls['from'].value,
      subject: this.contactForm.controls['subject'].value,
      message: this.contactForm.controls['comments'].value,
      listingUrl: this.contactForm.controls['listingUrl'].value
    }

    this.isLoading = true;

    this.leadService.shareListing(payload, recaptchaKey )
    .then(() => {
      this.isLoading = false;
      this.submitted.emit(false);
    })
    .catch(err => {
      this.isLoading = false;
      this.errorService.displayError(ErrorKey.lead, err.error.errorCode, 30);
    })
  }

  get from() { return this.contactForm.controls['from']; }
  get email() { return this.contactForm.controls['email']; }
  get subject() { return this.contactForm.controls['subject']; }
  get listingUrl() { return this.contactForm.controls['listingUrl']; }
  get comments() { return this.contactForm.controls['comments']; }

}
